import { PaymentStatusTag } from '@area/payments/components/PaymentStatusTag';
import { PaymentShortResponse } from '@api/admin/adminGeneratedApi';
import { DateService } from '@services/DateService';
import { Column } from '@components/Table/types';
import { HumanService } from '@services/HumanService';
import { ActionButton } from './ActionButton';

export const getColumns = (refetchPayments: () => void): Column<PaymentShortResponse>[] => [
  {
    width: 140,
    title: 'Статус',
    dataIndex: 'status',
    align: 'left',
    render: (value: PaymentShortResponse['status']) => <PaymentStatusTag status={value} />,
  },
  {
    width: 120,
    title: 'Номер',
    dataIndex: 'number',
    align: 'left',
    ellipsis: true,
  },
  {
    width: 200,
    title: 'Дата создания',
    dataIndex: 'createdAt',
    render: (value) => (value ? DateService.getLocalDate(value) : ''),
  },
  {
    width: 200,
    title: 'Дата подтверждения',
    dataIndex: 'approvedAt',
    render: (value) => (value ? DateService.getLocalDate(value) : ''),
  },
  {
    width: 200,
    title: 'Инициатор',
    dataIndex: 'startedBy',
    render: (value) => {
      if (value.lastName) {
        return HumanService.getShortHumanName(value);
      }
      return value.nickname || value.email;
    },
  },
  {
    width: 160,
    title: 'Кол-во студентов',
    dataIndex: 'studentsCount',
  },
  {
    width: 160,
    title: 'Сессия',
    dataIndex: 'period',
  },
  // {
  //   title: 'Сумма, руб.',
  //   dataIndex: 'sum',
  //   render: (value) => NumberService.formatMoney(value),
  // },
  {
    title: '',
    dataIndex: 'status',
    key: 'action',
    align: 'right',
    render: (_, payment: PaymentShortResponse) => <ActionButton {...payment} onSuccess={refetchPayments} />,
  },
];
